export default {
  admin: {
    products: {
      holdingData: {
        deleteDataSingleDate: {
          button: "Supprimer",
          deleteSuccessText: "Les données de constituents ont été supprimées avec succès.",
          prompt: {
            delete: "Supprimer",
            text: (ctx) =>
              `Vous êtes sur le point de supprimer définitivement les constituents pour la date du ${ctx.named("date")}. Si vous êtes sûr(e), cliquez sur le bouton ci-dessous pour confirmer.`,
            title: "Supprimer les données constituents",
          },
        },
        deletePropertyMetadata: {
          deleteSuccessText: "La propriété a été supprimée avec succès.",
          prompt: {
            cancel: "Annuler",
            delete: "Supprimer",
            deleteForDate: (ctx) => `Pour la date du ${ctx.named("selectedDate")}`,
            deleteGlobally: "Globalement",
            text: (ctx) =>
              `Vous êtes sur le point de supprimer la propriété "${ctx.named("propertyToDelete")}". Souhaitez-vous la supprimer globalement ou uniquement pour cette date ?`,
            title: "Supprimer une propriété",
          },
        },
        enrichDataSingleDate: {
          button: "Enrichir depuis un CSV",
          enrichSuccessText: "Les données de constituents ont été enrichies avec succès.",
          emptyCsv: "Aucune donnée à importer — le fichier CSV est vide.",
          noPropertyToEnrich:
            "Aucune propriété définie par l’utilisateur n’a été trouvée pour enrichir les données actuelles.",
          enrichPrompt: {
            cancel: "Annuler",
            condition1:
              "Le fichier doit contenir une ligne d’en-tête avec au minimum : 'Holding name', 'Isin', 'Currency' et au moins une propriété supplémentaire définie par l’utilisateur.",
            condition2:
              "Chaque ligne doit comporter une combinaison unique de 'Holding name', 'Isin' et 'Currency'.",
            condition3:
              "Chaque combinaison de 'Holding name', 'Isin' et 'Currency' pour la date cible doit apparaître une seule fois dans le fichier CSV.",
            enrich: "Enrichir",
            text: "Veuillez télécharger un fichier CSV pour enrichir les données de constituents. Les conditions suivantes doivent être remplies :",
            title: "Enrichir les données de constituents",
          },
          enrichNewPropertyPrompt: {
            cancel: "Annuler",
            enrich: "Enrichir",
            isCategorical: "Catégorielle",
            isCategoricalTooltip:
              "Les propriétés catégorielles permettent de regrouper les positions dans des sections telles que 'Aperçu' et 'Fiche', à une date donnée ou sur une période. Ces propriétés peuvent être traduites dans la section d’ajustement des données de position. Si une propriété catégorielle est générée automatiquement (et non saisie manuellement), elle peut également être remplacée dans cette section.",
            isFfill: "Remplissage dans le futur",
            isFfillTooltip:
              "Lorsqu'aucune valeur n'est disponible à la date sélectionnée, la dernière valeur disponible avant cette date sera utilisée.",
            newProperty: "Nouvelle propriété",
            text: "Cette opération va créer de nouvelles propriétés. Veuillez vérifier les propriétés proposées et définir leurs paramètres par défaut. Remarque : même une légère différence dans le nom (sensible à la casse) entraînera la création d’une nouvelle propriété.",
            title: "Nouvelles propriétés détectées",
          },
          enrichErrorPrompt: {
            close: "Fermer",
            selectErrorType: "Sélectionner le type d’erreur :",
            title: "Erreurs d’enrichissement",
            columns: {
              currency: "Devise",
              firstRow: "Première ligne",
              holdingName: "Nom de la position",
              isin: "ISIN",
              rowIndex: "Index de ligne",
            },
            duplicatedHeader: {
              header: "En-têtes dupliqués :",
              title: "En-tête dupliqué",
              text: "Votre fichier CSV contient des en-têtes de colonne dupliqués. Veuillez les renommer afin que chaque en-tête soit unique.",
            },
            emptyHeader: {
              title: "En-tête vide",
              text: "Votre fichier CSV contient des en-têtes de colonne vides. Veuillez attribuer un nom à chaque colonne en utilisant au moins un caractère non vide.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Colonnes obligatoires manquantes :",
              title: "Incohérence de colonnes",
              text: "Assurez-vous que l’en-tête du fichier CSV contient au moins (sensibles à la casse) : Holding name, Isin, Currency.",
            },
            duplicatedConstituent: {
              title: "Doublon de position",
              text: "Supprimez les entrées en double pour une même position.",
            },
            missingConstituent: {
              title: "Position manquante",
              text: "Ajoutez les positions manquantes afin que le CSV couvre entièrement la date sélectionnée.",
            },
            papaparseMissingQuotes: {
              title: "Guillemet non fermé",
              text: "L’analyse du fichier CSV a échoué car une chaîne entre guillemets n’a pas été correctement fermée. Veuillez vérifier l’absence de guillemets de fermeture dans vos données.",
            },
            papaparseUndetectableDelimiter: {
              title: "Délimiteur indétectable",
              text: "L’analyse du fichier CSV a échoué. Aucun délimiteur courant n’a été détecté. Veuillez vous assurer que votre fichier utilise un seul type de délimiteur, généralement une virgule ou un point-virgule.",
            },
            papaparseTooFewFields: {
              title: "Trop peu de champs",
              text: "L’analyse du fichier CSV a échoué. Chaque ligne doit contenir le même nombre de colonnes que l’en-tête. Actuellement, certaines lignes ont moins de colonnes que prévu. Veuillez vérifier la structure de votre fichier.",
            },
            papaparseTooManyFields: {
              title: "Trop de champs",
              text: "L’analyse du fichier CSV a échoué. Chaque ligne doit contenir le même nombre de colonnes que l’en-tête. Actuellement, certaines lignes ont plus de colonnes que prévu. Veuillez vérifier la structure de votre fichier.",
            },
          },
        },
        exportDataSingleDate: {
          button: "Exporter en CSV",
        },
        importDataSingleDate: {
          button: "Importer depuis un CSV",
          emptyCsv: "Aucune donnée à importer — le fichier CSV est vide.",
          importSuccessText: "Les données de constituents ont été importées avec succès.",
          importPrompt: {
            cancel: "Annuler",
            condition1:
              "Le fichier doit contenir une ligne d’en-tête avec au minimum : 'Holding name', 'Isin', 'Currency', 'value' et 'weight'.",
            condition2:
              "Chaque ligne doit comporter une combinaison unique de 'Holding name', 'Isin' et 'Currency'.",
            condition3:
              "Chaque 'value' et 'weight' doit être un nombre au format standard (point comme séparateur décimal, pas de séparateur de milliers).",
            date: "Date",
            import: "Importer",
            text: "Veuillez télécharger un fichier CSV pour importer des données de constituents. Les conditions suivantes doivent être remplies :",
            title: "Importer les données de constituents",
          },
          importNewPropertyPrompt: {
            cancel: "Annuler",
            import: "Importer",
            isCategorical: "Catégorielle",
            isCategoricalTooltip:
              "Les propriétés catégorielles permettent de regrouper les positions dans des sections telles que 'Aperçu' et 'Fiche', à une date donnée ou sur une période. Ces propriétés peuvent être traduites dans la section d’ajustement des données de position. Si une propriété catégorielle est générée automatiquement (et non saisie manuellement), elle peut également être remplacée dans cette section.",
            isFfill: "Remplissage dans le futur",
            isFfillTooltip:
              "Lorsqu'aucune valeur n'est disponible à la date sélectionnée, la dernière valeur disponible avant cette date sera utilisée.",
            newProperty: "Nouvelle propriété",
            text: "Cet import va créer de nouvelles propriétés. Veuillez vérifier les propriétés proposées et définir leurs paramètres par défaut. Remarque : même une légère différence dans le nom (sensible à la casse) entraînera la création d’une nouvelle propriété.",
            title: "Nouvelles propriétés détectées",
          },
          importErrorsPrompt: {
            close: "Fermer",
            selectErrorType: "Sélectionner le type d’erreur :",
            title: "Erreurs d’importation",
            columns: {
              currency: "Devise",
              firstRow: "Première ligne",
              holdingName: "Nom de la position",
              isin: "ISIN",
              rowIndex: "Index de ligne",
            },
            duplicatedHeader: {
              header: "En-têtes dupliqués :",
              title: "En-tête dupliqué",
              text: "Votre fichier CSV contient des en-têtes de colonne dupliqués. Veuillez les renommer afin que chaque en-tête soit unique.",
            },
            emptyHeader: {
              title: "En-tête vide",
              text: "Votre fichier CSV contient des en-têtes de colonne vides. Veuillez attribuer un nom à chaque colonne en utilisant au moins un caractère non vide.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Colonnes obligatoires manquantes :",
              title: "Incohérence de colonnes",
              text: "Assurez-vous que l’en-tête du fichier CSV contient au moins (sensibles à la casse) : Holding name, Isin, Currency, value, weight.",
            },
            duplicatedConstituent: {
              title: "Doublon de position",
              text: "Supprimez les entrées en double pour une même position.",
            },
            missingValue: {
              title: "Valeur manquante",
              text: "Certaines lignes ne contiennent pas de valeur. Assurez-vous que chaque ligne en contient une, correctement formatée.",
            },
            invalidValueFormat: {
              title: "Format de valeur invalide",
              text: "Le format de la colonne 'value' n’a pas pu être déterminé. Utilisez un point comme séparateur décimal et n’utilisez pas de séparateur de milliers.",
            },
            missingWeight: {
              title: "Poids manquant",
              text: "Certaines lignes ne contiennent pas de poids. Assurez-vous que chaque ligne en contient un, correctement formaté.",
            },
            invalidWeightFormat: {
              title: "Format de poids invalide",
              text: "Le format de la colonne 'weight' n’a pas pu être déterminé. Utilisez un point comme séparateur décimal et n’utilisez pas de séparateur de milliers.",
            },
            papaparseMissingQuotes: {
              title: "Guillemet non fermé",
              text: "L’analyse du fichier CSV a échoué car une chaîne entre guillemets n’a pas été correctement fermée. Veuillez vérifier l’absence de guillemets de fermeture dans vos données.",
            },
            papaparseUndetectableDelimiter: {
              title: "Délimiteur indétectable",
              text: "L’analyse du fichier CSV a échoué. Aucun délimiteur courant n’a été détecté. Veuillez vous assurer que votre fichier utilise un seul type de délimiteur, généralement une virgule ou un point-virgule.",
            },
            papaparseTooFewFields: {
              title: "Trop peu de champs",
              text: "L’analyse du fichier CSV a échoué. Chaque ligne doit contenir le même nombre de colonnes que l’en-tête. Actuellement, certaines lignes ont moins de colonnes que prévu. Veuillez vérifier la structure de votre fichier.",
            },
            papaparseTooManyFields: {
              title: "Trop de champs",
              text: "L’analyse du fichier CSV a échoué. Chaque ligne doit contenir le même nombre de colonnes que l’en-tête. Actuellement, certaines lignes ont plus de colonnes que prévu. Veuillez vérifier la structure de votre fichier.",
            },
          },
        },
        updatePropertyMetadata: {
          saveSuccessText: "La propriété a été mise à jour avec succès.",
          unsavedChangesAlert:
            "Vous avez des modifications non enregistrées. Si vous quittez maintenant, elles seront perdues.",
          prompt: {
            isCategorical: "Catégorielle",
            isCategoricalTooltip:
              "Les propriétés catégorielles permettent de regrouper les positions dans des sections telles que 'Aperçu' et 'Fiche', à une date donnée ou sur une période. Ces propriétés peuvent être traduites dans la section d’ajustement des données de position. Si une propriété catégorielle est générée automatiquement (et non saisie manuellement), elle peut également être remplacée dans cette section.",
            isFfill: "Remplissage dans le futur",
            isFfillTooltip:
              "Lorsqu'aucune valeur n'est disponible à la date sélectionnée, la dernière valeur disponible avant cette date sera utilisée.",
            propertyForUrl: "Propriété de lien",
            propertyForUrlTooltip:
              "Indiquez le nom de la propriété contenant l’URL. La valeur de la propriété actuelle sera utilisée comme texte cliquable.",
            title: "Mettre à jour la propriété",
            translation: "Traduction",
          },
        },
      },
    },
  },
  auth: {
    resetPasswordLink: {
      forgotPassword: "Mot de passe oublié?",
    },
  },
  cards: {
    needLoginCard: {
      needLogged: "Vous devez être connecté pour voir ce contenu.",
    },
  },
  compliance: {
    cookies: {
      buttonText: "Accepter",
      cookiesUsage:
        "Ce site Web utilise des cookies pour améliorer sa convivialité. En utilisant ce site Web, vous déclarez votre consentement à l'utilisation de cookies, ainsi qu'à la politique de confidentialité où vous trouverez de plus amples informations sur les cookies. Lien: {0}.",
      privacyPolicy: "Politique de confidentialité",
    },
  },
  components: {
    biggestDrawdownsTable: {
      rank: "Rang",
      startDate: "Date de début",
      troughDate: "Date de creux",
      recoveryDate: "Date de reprise",
    },
    stressTestScenariosTable: {
      scenario: "Scénario",
      period: "Période",
      scenarioExtremelyBad: "Extrêmement défavorable",
      scenarioUnfavourable: "Défavorable",
      scenarioModerate: "Modéré",
      scenarioFavourable: "Favorable",
    },
    liquidityRiskScenarioTable: {
      timeToLiquidate: "Délai de liquidation",
      timeBucket1Day: "0-1 jour",
      timeBucket2To7Days: "2-7 jours",
      timeBucket8To30Days: "8-30 jours",
      timeBucket31To90Days: "31-90 jours",
      timeBucket91To180Days: "91-180 jours",
      timeBucket181To365Days: "181-365 jours",
      timeBucketMoreThan365Days: ">365 jours",
      waterfallCumulativeWeight: "Cascade poids cumulatif",
      proRataCumulativeWeight: "Au prorata poids cumulatif",
      nearProportionalCumulativeWeight: "Quasi proportionnel poids cumulatif",
    },
    details: {
      report: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} million${ctx.named("aum") > 1000000 ? "s" : ""}${
            ctx.named("asOfDate") ? ` (au ${ctx.named("asOfDate")})` : ""
          }`,
        lastPrice: (ctx) => `${ctx.named("currency")} ${ctx.named("lastPrice")}`,
      },
      overview: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} million${ctx.named("aum") > 1000000 ? "s" : ""} (au ${ctx.named("asOfDate")})`,
        lastPrice: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("lastPrice")} (au ${ctx.named("asOfDate")})`,
      },
    },
    returnsVarGraph: {
      dailyReturn: "Rendement journalier",
      twoWeekReturn: "Rendement 2 semaines",
      monthlyReturn: "Rendement mensuel",
      oneDayOnePercent: "VaR 1 jour (99%)",
      oneDayFivePercent: "VaR 1 jour (95%)",
      twoWeeksOnePercent: "VaR 2 semaines (99%)",
      twoWeeksFivePercent: "VaR 2 semaines (95%)",
      oneMonthOnePercent: "VaR 1 mois (99%)",
      oneMonthFivePercent: "VaR 1 mois (95%)",
    },
    download: {
      tooltip: "Télécharger en tant qu'image",
      prompt: {
        downloadPngButton: "Télécharger en PNG",
        downloadSvgButton: "Télécharger en SVG",
        text: "Choisissez le format dans lequel vous souhaitez télécharger le composant.",
        title: "Télécharger le composant",
      },
    },
    portfolioBreakdownOnDate: {
      noDataYet: "Ce composant ne contient pas encore de données.",
    },
    portfolioBreakdownOverTime: {
      noDataYet: "Ce composant n'a pas encore suffisamment de données.",
    },
    statisticsWithPeriods: {
      noStatisticsToDisplay: "Aucune statistique à afficher.",
    },
    statistics: {
      noStatisticsToDisplay: "Aucune statistique à afficher.",
    },
    operations: {
      statuses: {
        failed: "Échoué",
        pending: "En attente",
        running: "En cours",
        succeeded: "Réussi",
      },
    },
  },
  datePickers: {
    datePicker: {
      selectDateTooltip: "Choisir une date",
    },
    dateRangePicker: {
      from: "De (aaaa-mm-jj)",
      fullPeriod: "Période complète",
      to: "À (aaaa-mm-jj)",
    },
    zoomPicker: {
      fiveYears: "5A",
      fullPeriod: "MAX",
      oneMonth: "1M",
      oneYear: "1A",
      sevenYears: "7A",
      sixMonths: "6M",
      threeMonths: "3M",
      tenYears: "10Y",
      threeYears: "3A",
      twoYears: "2A",
      ytd: "YTD",
    },
  },
  dropdowns: {
    iconsDropdown: {
      noIcon: "Pas d'icône",
    },
  },
  editPrompt: {
    copyInAllLangs: "Copier dans toutes les langues",
    editField: "Modifier le champ",
    enterText: "Entrer un texte",
    overwriteDataAllShareClasses: "Écraser les données de toutes les classes de parts",
    propertyFilters: {
      title: "Filtres de propriété",
      tooltip:
        "Pour être pris en compte, une position doit passer tous les filtres appliqués. Une position passe un filtre si elle correspond à l'une de ses valeurs sélectionnées.",
      property: "Propriété",
      values: "Valeurs",
      empty: "Aucun filtre de propriété pour le moment.",
      add: "Ajouter un filtre de propriété",
      multiSelect: {
        placeholder: "Sélectionnez des valeurs",
        selectLabel: "Appuyez sur la touche Entrée pour sélectionner",
        deselectLabel: "Appuyez sur la touche Entrée pour supprimer",
        selectedLabel: "Sélectionné",
        limitText: (ctx) => `et ${ctx.named("count")} de plus`,
      },
    },
    id: "ID",
    idTooltip:
      "Cet identifiant unique sert de référence pour le composant au sein de la plateforme. Chaque composant que vous créez doit avoir un identifiant distinct. Nous recommandons la convention suivante pour une meilleure lisibilité : utiliser le titre du composant, le convertir en minuscules, remplacer les espaces par des tirets. Pour un composant intitulé 'Mon tableau analytique', l'identifiant serait 'mon-tableau-analytique'.",
    needUniqueId:
      "L'identifiant fourni est actuellement utilisé par un autre composant dans l'emplacement actuel ou dans un emplacement lié. Veuillez fournir un identifiant distinctif pour garantir l'unicité.",
    numberOfDecimals: "Nombre de décimales",
    numberOfDecimalsTooltip:
      "Le nombre de décimales pour tous les nombres affichés dans le composant. Notez que ça n'inclut pas les axes des graphiques.",
    withBenchmark: "Montrer avec la benchmark",
    resamplingStrategy: "Stratégie de rééchantillonnage",
    windowHorizon: "Fenêtre glissante",
    windowHorizonTooltip:
      "La fenêtre glissante détermine le 'look-back' utilisé pour calculer la volatilité annuelle à chaque point du graphique. Un horizon plus court (par exemple, 3 mois) rend le graphique très sensible aux chocs de marché et aux changements de régime brusques, bien qu'il puisse sembler 'bruité' en raison de fluctuations temporaires. En revanche, un horizon plus long (par exemple, 1 an) offre une vue plus lisse et stable des risques à long terme, en filtrant le bruit court terme du marché, bien qu'il réagisse plus lentement aux événements actuels. Notez que choisir un horizon plus long entraîne également un début plus tardif sur le graphique, car le calcul nécessite une période historique complète avant que le premier valeur puisse être tracée.",
    windowHorizonOptions: {
      threeMonths: "3 mois",
      sixMonths: "6 mois",
      oneYear: "1 an",
      twoYears: "2 ans",
      threeYears: "3 ans",
      fiveYears: "5 ans",
      sevenYears: "7 ans",
      tenYears: "10 ans",
    },
    timeWindow: "Fenêtre temporelle",
    timeWindowOptions: {
      threeMonths: "3 mois",
      sixMonths: "6 mois",
      oneYear: "1 an",
      twoYears: "2 ans",
      threeYears: "3 ans",
      fourYears: "4 ans",
      fiveYears: "5 ans",
      sixYears: "6 ans",
      sevenYears: "7 ans",
      eightYears: "8 ans",
      nineYears: "9 ans",
      tenYears: "10 ans",
      all: "Tout",
    },
    valueAtRisk: "Value at risk",
    valueAtRiskOptions: {
      oneDayOnePercent: "VaR 1 jour (99%)",
      oneDayFivePercent: "VaR 1 jour (95%)",
      twoWeeksOnePercent: "VaR 2 semaines (99%)",
      twoWeeksFivePercent: "VaR 2 semaines (95%)",
      oneMonthOnePercent: "VaR 1 mois (99%)",
      oneMonthFivePercent: "VaR 1 mois (95%)",
    },
    footnote: "Texte sous le composant",
    placeholderFootnote:
      "Un texte qui apparaît en dessous du composant. Par exemple, 'Les frais sont inclus'",
    langTabError: "Certains champs ne sont pas valides dans les langues suivantes:",
    settingsOnlyUsedOnOverviewTooltip: "Ce paramètre ne concerne que la vue 'Aperçu'.",
    startDate: "Date de début",
    startDateTooltip:
      "Sélectionnez une date de début (au format AAAA-MM-JJ) pour le composant. Le composant s'ajustera automatiquement pour afficher les données à partir de la première date disponible pour le produit ou de la date que vous avez choisie, selon celle qui est la plus tardive. Si vous laissez ce champ vide, toutes les données de prix disponibles pour le produit seront affichées.",
    tabError: "Certains champs ne sont pas valides",
    title: "Titre",
    titleEdit: (ctx) => `Éditer ${ctx.named("componentId")}`,
    titleAdd: "Ajouter un composant",
    unsavedChangesAlert:
      "Vous avez des modifications non enregistrées. Si vous quittez sans sauvegarder, elles seront perdues.",
    resamplingStrategyOptions: {
      standard: "Standard",
      standardTooltip:
        "Ajuste automatiquement le niveau de détail en fonction de la période sélectionnée pour maintenir la clarté et la lisibilité du graphique.",
      monthly: "Mensuel",
      monthlyTooltip:
        "Affiche la dernière valeur enregistrée pour chaque mois de la période sélectionnée.",
    },
    reportFooter: {
      saveSuccess: "Le pied de page a été mis à jour avec succès",
      title: "Pied de page",
      text: "Texte",
      showPageNumber: "Afficher le numéro de page",
      showFooterLine: "Afficher la ligne de bas de page",
      margins: {
        bottom: "Bas",
        left: "Gauche",
        right: "Droite",
        title: "Marges (mm)",
      },
    },
    reportHeader: {
      backgroundImage: "Image de fond",
      backgroundImageTooltip:
        "Les dimensions de l'en-tête étant de 794 pixels en largeur et la hauteur choisie (voir ci-dessous), il convient d'utiliser une image dont les dimensions respectent le même ratio pour obtenir le meilleur résultat.",
      logo: "Logo",
      text: "Texte",
      saveSuccess: "L'en-tête a été mis à jour avec succès",
      showDateRange: "Afficher la plage de dates",
      textInPrimary: "Texte en couleur de la marque",
      title: "En-tête",
      useCompanyLogo: "Utiliser le logo de l'entreprise",
      logoPosition: {
        left: "Gauche",
        right: "Droite",
        title: "Position du logo",
      },
      datePosition: {
        bottomLeft: "En bas à gauche",
        bottomRight: "En bas à droite",
        centerLeft: "Au centre à gauche",
        centerRight: "Au centre à droite",
        hidden: "Cachée",
        title: "Position de la date",
        topLeft: "En haut à gauche",
        topRight: "En haut à droite",
      },
      headerVisibility: {
        allPages: "Toutes les pages",
        hidden: "Masqué",
        onlyFirstPage: "Uniquement sur la première page",
        title: "Visibilité de l'en-tête",
      },
      height: {
        title: "Hauteur",
        large: "Grande (200 px / ~52,90 mm)",
        normal: "Normale (150 px / ~39,67 mm)",
        small: "Petite (100 px / ~26,45 mm)",
        veryLarge: "Très grande (250 px / ~66,12 mm)",
      },
      margins: {
        bottom: "Bas",
        left: "Gauche",
        right: "Droite",
        top: "Haut",
        title: "Marges (mm)",
        tooltip: "Les marges n'ont pas d'incidence sur l'image d'arrière-plan.",
      },
      productNamePosition: {
        bottomLeft: "En bas à gauche",
        bottomRight: "En bas à droite",
        centerLeft: "Au centre à gauche",
        centerRight: "Au centre à droite",
        hidden: "Masqué",
        title: "Position du nom du produit",
        topLeft: "En haut à gauche",
        topRight: "En haut à droite",
      },
      textPosition: {
        bottomLeft: "En bas à gauche",
        bottomRight: "En bas à droite",
        centerLeft: "Au centre à gauche",
        centerRight: "Au centre à droite",
        title: "Position du texte",
        topLeft: "En haut à gauche",
        topRight: "En haut à droite",
      },
    },
    reportStyle: {
      primaryColor: "Couleur principale",
      colorSchemePicker: "Sélecteur de palette de couleurs",
      colorSchemeTooltip:
        "Cette palette de couleurs s’applique actuellement aux graphiques en secteurs et en anneaux. Si aucune couleur n’est fournie, les graphiques utilisent par défaut la palette générale de la plateforme.",
      saveSuccess: "Le style a été mis à jour avec succès",
      title: "Style",
      fontSize: {
        normal: "Normale",
        large: "Grande",
        small: "Petite",
        title: "Taille de la police",
      },
      margins: {
        left: "Gauche",
        right: "Droite",
        title: "Marges (mm)",
      },
      spacing: {
        comfortable: "Confortable",
        compact: "Compact",
        title: "Espacement",
      },
      titleBorder: {
        above: "Au-dessus du titre",
        below: "En-dessous du titre",
        none: "Pas de soulignement",
        title: "Soulignement du titre",
      },
      titlesBold: {
        title: "Titres des composants en gras",
      },
    },
    genericComponent: {
      addColumn: "Ajouter une colonne",
      addRow: "Ajouter une ligne",
      addData: "Ajouter une donnée",
      cantChangeType:
        "Vous ne pouvez pas modifier le type d'un composant générique une fois que vous l'avez enregistré. Si vous souhaitez un type différent, vous devez créer un nouveau composant générique.",
      columnWithIndex: (ctx) => `Colonne ${ctx.named("idx")}`,
      data: "Donnée",
      date: "Date",
      displayValuesAsPerc: "Affiche les valeurs en pourcentage",
      displayValuesAsPercTooltip: "Affiche les valeurs avec un symbole '%' dans le graphique",
      donutChart: "Graphique en donut",
      exampleSector: "Ex., Secteurs",
      header: "En-tête",
      horizontalBarChart: "Diagramme à barres horizontales",
      key: "Légende",
      image: "Image",
      lineChart: "Graphique linéaire",
      needData:
        "Vous ne pouvez pas sauvegarder un composant générique sans aucune donnée ou partiellement rempli. Supprimez-le, ajoutez une donnée ou complétez les données manquantes avant de sauvegarder.",
      pieChart: "Graphique circulaire",
      removeData: "Supprimer la donnée",
      showColumnHeader: "Afficher l'en-tête de la colonne",
      table: "Tableau",
      text: "Texte",
      type: "Type",
      value: "Valeur",
      verticalBarChart: "Diagramme à barres verticales",
      video: "Vidéo",
      weightPercent: "Poids (en %)",
      lineChartSection: {
        fileMust: "Votre fichier doit :",
        selectFile: "Sélectionner un fichier",
        uploadCsv: "Importez un fichier CSV contenant vos données de série temporelle.",
        conditions: {
          dateFormat: "Utiliser le format de date <strong>YYYY-MM-DD</strong>.",
          dateIncreaseAndUnique: "Contenir des dates strictement croissantes et uniques.",
          headerRow:
            "Inclure une ligne d’en-tête avec les colonnes <code>date</code> et <code>value</code>.",
          maxPoints:
            "Avoir au maximum <strong>500 lignes</strong> et une taille de fichier inférieure à <strong>1&nbsp;Mo</strong>.",
          numberFormat:
            "Utilisez un point (.) comme séparateur décimal et n’incluez aucun séparateur de milliers.",
        },
        errors: {
          exceedSize: {
            title: "Fichier trop volumineux",
            text: "Le fichier importé dépasse 1&nbsp;Mo. Veuillez le limiter à un maximum de 500 points de données.",
          },
          invalidData: {
            title: "Données invalides détectées",
            text: "Certaines lignes contiennent des valeurs manquantes ou invalides. Assurez-vous que la colonne <code>date</code> utilise le format <strong>YYYY-MM-DD</strong> et que la colonne <code>value</code> contient des nombres valides.",
          },
          invalidDataSequence: {
            title: "Séquence de dates invalide",
            text: "Les dates doivent être strictement croissantes et uniques. Corrigez votre fichier et réessayez.",
          },
          parseFail: {
            title: "Échec de l’analyse",
            text: "Le fichier CSV n’a pas pu être lu correctement. Vérifiez son format et réessayez. Si le problème persiste, contactez l’équipe Alquant.",
          },
          tooManyDataPoints: {
            title: "Trop de points de données",
            text: "Votre fichier contient plus de 500 lignes. Réduisez-le à 500 ou moins avant de le télécharger.",
          },
          unexpectedError: {
            title: "Erreur inattendue",
            text: "Une erreur inattendue s’est produite lors du traitement de votre fichier. Veuillez contacter l’équipe Alquant pour obtenir de l’aide.",
          },
        },
      },
    },
    contacts: {
      addContact: "Ajouter un contact",
      contacts: "Contacts",
      contactsPerRow: "Contacts par ligne",
      additionalText: "Texte supplémentaire",
      email: "E-mail",
      exampleEmail: "Ex., jdoe@mail.com",
      exampleName: "Ex., John Doe",
      examplePhone: "Ex., +41 79 123 45 67",
      exampleRole: "Ex., Partenaire",
      image: "Image",
      name: "Nom",
      phone: "Téléphone",
      removeContact: "Supprimer le contact",
      role: "Rôle",
    },
    dialog: {
      copyInAllLangs: {
        title: "Copier dans toutes les langues",
        text: "Vous allez copier toutes les valeurs de la langue actuelle dans toutes les autres langues. En êtes-vous sûr(e)?",
      },
      saveFieldInAllShareClasses: {
        title: "Écraser",
        text: "Vous êtes sur le point d'écraser ce champ dans toutes les autres classes de parts de ce produit, pas seulement la classe de parts actuelle. Etes-vous sûr(e)?",
      },
      saveInAllShareClasses: {
        title: "Écraser",
        text: (ctx) =>
          `Vous êtes sur le point d'écraser les données "${ctx.named(
            "tabName"
          )}" de toutes les autres classes de parts de ce produit avec les données "${ctx.named(
            "tabName"
          )}" de cette classe de parts (pas seulement les derniers changements que vous avez effectués). Etes-vous sûr(e)?`,
      },
    },
    description: {
      contentTitle: "Description",
    },
    disclaimer: {
      contentTitle: "Clause de non-responsabilité",
      defaultWarning:
        "Vous n'avez actuellement pas de clause de non-responsabilité pour ce produit. C'est pourquoi la clause de non-responsabilité standard a été utilisée. Si vous rédigez une clause de non-responsabilité ici, elle s'affichera uniquement pour ce produit.",
    },
    historicalPricesChart: {
      adjusted: "Utiliser les prix ajustés",
      adjustedTooltip:
        "En général, les prix ajustés désignent les prix qui sont ajustés pour tenir compte des dividendes, des splits et d'autres événements. Les prix non ajustés sont simplement le coût d'une action du produit à la fin de la journée.",
      defaultLogScale: "Par défaut dans l'échelle logarithmique",
      showLogScaleSwitch: "Afficher le switch d'échelle logarithmique",
      priceIndexedTo100: "Utiliser les prix indexés à 100",
    },
    portfolioBreakdown: {
      cantChangeProperty:
        "Vous ne pouvez pas modifier la propriété d'un composant de position une fois qu'il a été enregistré. Si vous souhaitez une autre propriété, vous devez créer un nouveau composant.",
      chartType: "Type de graphique",
      displayOrder: "Ordre d'affichage",
      donutChart: "Graphique en donut",
      horizontalBarChart: "Diagramme à barres horizontales",
      lagRule: "Règle de décalage des données",
      lagRuleTooltip:
        "Choisissez le décalage à appliquer aux données affichées dans ce composant. Par exemple, un décalage de deux fins de mois signifie que les données les plus récentes disponibles deux mois plus tôt seront affichées. Si nous sommes le 15 janvier 2025, les données affichées iront jusqu’au 30 novembre 2024.",
      pieChart: "Graphique circulaire",
      property: "Propriété",
      table: "Tableau",
      verticalBarChart: "Diagramme à barres verticales",
      onlyShowTopThenOthers: {
        title: "Afficher les premiers uniquement",
        tooltip:
          'N\'afficher que les X premiers (nombre choisi), et fusionner les autres dans "Autres". Laisser vide pour tout afficher.',
      },
      categoryIdsInOthers: {
        title: 'Éléments à considérer comme "Autres"',
        multiSelect: {
          placeholder: "Sélectionnez des éléments",
          selectLabel: "Appuyez sur la touche Entrée pour sélectionner",
          deselectLabel: "Appuyez sur la touche Entrée pour supprimer",
          selectedLabel: "Sélectionné",
          limitText: (ctx) => `et ${ctx.named("count")} de plus`,
        },
      },
      sortOptions: {
        alphabeticallyAscending: "Nom (A → Z)",
        alphabeticallyDescending: "Nom (Z → A)",
        weightAscending: "Poids (faible → élevé)",
        weightDescending: "Poids (élevé → faible)",
      },
      lagRuleOptions: {
        noLag: "Aucun décalage (données les plus récentes)",
        oneMonthEnd: "Fin de mois précédente",
        twoMonthEnd: "Fin de mois d’il y a deux mois",
      },
      normalizeBreakdownWeight: "Normaliser les poids",
      normalizeBreakdownWeightTooltip:
        "Si cette option est activée, les poids sont mis à l’échelle pour totaliser 100 % sur toutes les catégories à la date choisie (ou sur chaque date de la série temporelle).",
    },
    keyCharacteristics: {
      addKeyCharacteristics: "Ajouter une caractéristique clé",
      exampleDynamicExposure: "Ex., Exposition dynamique",
      exampleWeDynamicallyAdapt: "Ex., Nous adaptons dynamiquement ...",
      header: "En-tête",
      icon: "Icône",
      paragraph: "Paragraphe",
      removeKeyCharacteristics: "Supprimer la caractéristique clé",
    },
    biggestDrawdownsTable: {
      numberOfDrawdowns: "Nombre de drawdowns",
    },
    stressTestScenariosTable: {
      product: "Produit",
      benchmark: "Benchmark",
      periods: "Périodes",
      addPeriod: "Ajouter une période",
      deletePeriod: "Supprimer la période",
    },
    liquidityAnalysisTable: {
      customizedTable: "Aperçu du tableau",
      holdingsToIgnore: {
        title: "Positions à ignorer",
        holdingsMultiselect: {
          placeholder: "Sélectionnez les positions à ignorer",
          selectLabel: "Appuyez sur la touche Entrée pour sélectionner",
          deselectLabel: "Appuyez sur la touche Entrée pour supprimer",
          selectedLabel: "Sélectionné",
          limitText: (ctx) => `et ${ctx.named("count")} de plus`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Ignorer les holdings dont le nom contient",
        placeholder: "ex. Trésorerie, Autres",
      },
    },
    liquidityRiskScenarioTable: {
      rowsByTimeBucket: "Données par délai de liquidation",
      amountPlaceholder: "Montant (Mio)",
      weightPlaceholder: "Poids (%)",
    },
    monthlyReturnsTable: {
      descending: "Trier les années par ordre décroissant",
      benchmark: "Benchmark",
      product: "Produit",
      return: "Rendement",
      nameReplacements: "Remplacer les noms par défaut",
      nameReplacementsTooltip:
        "Personnalisez le nom du produit et de la benchmark dans le composant. Laissez vide pour conserver les noms existants par défaut.",
    },
    notify: {
      componentSaveSuccess: (ctx) =>
        `Votre composant '${ctx.named("componentId")}' a été mis à jour avec succès.`,
    },
    overviewHeader: {
      backgroundImage: "Image de fond",
      backgroundImageTooltip:
        "Veuillez noter que l'image en cours d'examen est également utilisée comme image de la fiche produit sur la page d'accueil. Par conséquent, toute modification de cette image affectera simultanément la représentation du produit sur la page d'accueil",
      hideProductName: "Cacher le nom du produit",
      text: "Texte",
      textInPrimary: "Texte en couleur de la marque",
      textTooltip:
        "Veuillez noter que le texte actuellement à l'étude est également utilisé comme texte de la fiche produit sur la page d'accueil. Par conséquent, toute modification de ce texte affectera simultanément la représentation du produit sur la page d'accueil.",
      showDownloadLastFactsheetButton:
        'Afficher le bouton "@:components.extras.downloadLastFactsheet.downloadLastFactsheet"',
      showDownloadLastFactsheetButtonTooltip:
        'Pour que le bouton soit visible par un utilisateur, un document doit être marqué comme "@:pages.products.documents.prompt.uploadFile.shouldConsiderLastFactsheet" dans la section "Documents", et il doit être disponible dans la langue sélectionnée par l\'utilisateur.',
      saveSuccess: "L'en-tête a été mis à jour avec succès",
      showFollowButton: "Afficher le bouton pour suivre le produit",
      title: "Éditer l'en-tête de l'aperçu",
    },
    overviewStyle: {
      colorSchemePicker: "Sélecteur de palette de couleurs",
      colorSchemeTooltip:
        "Cette palette de couleurs s’applique actuellement aux graphiques en secteurs et en anneaux. Si aucune couleur n’est fournie, les graphiques utilisent par défaut la palette générale de la plateforme.",
      saveSuccess: "Le style a été mis à jour avec succès.",
      title: "Style",
      titlesBold: {
        title: "Titres des composants en gras",
      },
    },
    productDetails: {
      addDetail: "Ajouter un détail",
      exampleIsin: "Ex., ISIN",
      exampleLU: "Ex., LU2220388479",
      key: "Clé",
      noteDragAndDrop: "Remarque : faites glisser les lignes pour réorganiser les détails.",
      removeDetail: "Supprimer le détail",
      showAgio: "Montrer l'agio",
      showAuM: "Montrer l'AuM",
      showLastPrice: "Montrer le dernier prix",
      showIsin: "Montrer l'ISIN",
      showTer: "Montrer le TER",
      value: "Valeur",
    },
    relativePerformanceChart: {
      footnote: "Note de bas de page",
      placeholderFootnote:
        "Un texte qui apparaît sous le graphique. Par exemple, 'Les frais sont inclus'",
    },
    riskProfile: {
      level: "Niveau de risque",
    },
    shareClassesTable: {
      bloomberg: "Bloomberg",
      class: "Classe",
      column: "Colonne",
      columnsToShow: "Colonnes à afficher",
      showColumn: "Afficher la colonne",
      defaultFootnote:
        "Perf. lanc. : les rendements pour les périodes de plus d'un an depuis la création sont annualisés, et non annualisés s'ils sont inférieurs à un an.",
      footnote: "Note en-dessous de la table",
      inceptionDate: "Date de création",
      isin: "ISIN",
      mgmtFee: "Frais de gestion",
      minInvestment: "Inv. min.",
      perfFee: "Frais de perf.",
      ter: "TER",
      title: "Modifier le tableau des classes de parts",
    },
    statistics: {
      benchmark: "Benchmark",
      product: "Produit",
      nameReplacements: "Remplacer les noms par défaut",
      nameReplacementsTooltip:
        "Personnalisez le nom du produit et de la benchmark dans le composant. Laissez vide pour conserver les noms existants par défaut. Par exemple, utilisez un terme comme 'Produit' pour abréger et économiser de l'espace d'affichage.",
      fieldsToDisplay: "Champs à afficher",
      noteDragAndDrop: "Remarque : faites glisser les lignes pour réorganiser les statistiques.",
      shownStatisticName: "Nom de la statistique affichée",
      showStatistic: "Afficher la statistique",
      statisticId: "Identifiant de la statistique",
    },
    statisticsWithPeriods: {
      benchmark: "Benchmark",
      product: "Produit",
      nameReplacements: "Remplacer les noms par défaut",
      nameReplacementsTooltip:
        "Personnalisez le nom du produit et de la benchmark dans le composant. Laissez vide pour conserver les noms existants par défaut. Par exemple, utilisez un terme comme 'Produit' pour abréger et économiser de l'espace d'affichage.",
      fieldsToDisplay: "Champs à afficher",
      noteDragAndDrop: "Remarque : faites glisser les lignes pour réorganiser les statistiques.",
      periodsTitle: "Périodes à afficher",
      shownStatisticName: "Nom de la statistique affichée",
      showStatistic: "Afficher la statistique",
      statisticId: "Identifiant de la statistique",
      periods: {
        1: "1M",
        3: "3M",
        6: "6M",
        ytd: "YTD",
        12: "1A",
        36: "3A",
        60: "5A",
        84: "7A",
        120: "10A",
        max: "MAX",
      },
    },
    holdingsTable: {
      aggregateHoldings: "Regrouper les positions",
      aggregateHoldingsTooltip:
        "Regroupe la valeur et le poids des positions ayant le même 'Nom de la position', 'Isin' et 'Devise'. Toutes les autres propriétés sont reprises de la position ayant le poids le plus élevé dans le groupe. Vous pouvez contrôler ce regroupement dans 'Ajustements des données de position' → section 'Remplacer' en modifiant l’un de ces trois champs.",
      fieldsToDisplay: "Champs à afficher",
      lagRule: "Règle de décalage des données",
      lagRuleTooltip:
        "Choisissez le décalage à appliquer aux données affichées dans ce composant. Par exemple, un décalage de deux fins de mois signifie que les données les plus récentes disponibles deux mois plus tôt seront affichées. Si nous sommes le 15 janvier 2025, les données affichées iront jusqu’au 30 novembre 2024.",
      showHeader: "Afficher l'en-tête",
      showHoldingsCount:
        "Afficher « X positions sur Y » lorsque toutes les positions ne sont pas affichées",
      showTotal: "Afficher le total",
      numHoldings: {
        title: "Nombre de positions à afficher",
        tooltip:
          "Si vous laissez ce champ vide, toutes les données disponibles pour les avoirs du produit seront affichées.",
      },
      holdingsToIgnore: {
        title: "Holdings à ignorer",
        holdingsMultiselect: {
          placeholder: "Sélectionnez les holdings à ignorer",
          selectLabel: "Appuyez sur la touche Entrée pour sélectionner",
          deselectLabel: "Appuyez sur la touche Entrée pour supprimer",
          selectedLabel: "Sélectionné",
          limitText: (ctx) => `et ${ctx.named("count")} de plus`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Ignorer les holdings dont le nom contient",
        placeholder: "ex. Trésorerie, Autres",
      },
      propertyFilters: {
        property: "Propriété",
        multiSelect: {
          placeholder: "Sélectionnez des valeurs",
          selectLabel: "Appuyez sur la touche Entrée pour sélectionner",
          deselectLabel: "Appuyez sur la touche Entrée pour supprimer",
          selectedLabel: "Sélectionné",
          limitText: (ctx) => `et ${ctx.named("count")} de plus`,
        },
      },
      lagRuleOptions: {
        noLag: "Aucun décalage (données les plus récentes)",
        oneMonthEnd: "Fin de mois précédente",
        twoMonthEnd: "Fin de mois d’il y a deux mois",
      },
      displayOrder: "Ordre d'affichage",
      sortOptions: {
        alphabeticallyAscending: "Nom de la position (A → Z)",
        alphabeticallyDescending: "Nom de la position (Z → A)",
        weightAscending: "Poids (faible → élevé)",
        weightDescending: "Poids (élevé → faible)",
      },
      customizeTable: "Personnaliser la table",
      addColumn: "Ajouter une colonne",
      columnWithIndex: (ctx) => `Colonne ${ctx.named("idx")}`,
    },
  },
  extras: {
    changeRoles: {
      changeRoles: "Changer les rôles",
      notify: {
        errorText: "Aucun rôle n'a été mis à jour. Raison: ",
        successText: "Les rôles des utilisateurs ont été mis à jour.",
      },
    },
    deleteGenericComponent: {
      delete: "Supprimer",
      deleteAllComponents: "Supprimer tous les composants",
      deleteOnlyThisComponent: "Supprimer uniquement ce composant",
      deleting: "Suppression ...",
      deleteSuccess: "Suppression réussie",
      view: "Vue",
      shareClass: "Classe de parts",
      textIsNotLinked:
        "Vous êtes sur le point de supprimer définitivement un composant générique. Cette action ne peut être annulée. Veuillez confirmer que vous souhaitez procéder à la suppression.",
      textIsLinkedFirstPart:
        "Vous êtes sur le point de supprimer définitivement un composant générique. Cette action ne peut être annulée.  Notez que ce composant est lié au même(s) composant(s) dans ce qui suit: ",
      textIsLinkedSecondPart:
        "Veuillez confirmer que vous souhaitez procéder à la suppression et décider si vous souhaitez supprimer uniquement le composant actuel ou si vous souhaitez supprimer ce composant et tous les composants liés.",
      title: (ctx) => `Suppression permanente de  ${ctx.named("componentId")}`,
    },
    deleteUser: {
      button: "Supprimer",
      dialog: {
        confirm: "Supprimer l'utilisateur",
        text: "Êtes-vous sûr de vouloir supprimer définitivement cet utilisateur ?",
        title: "Supprimer l'utilisateur",
      },
      notify: {
        errorText: "Échec de la suppression de l'utilisateur.",
        successText: "L'utilisateur a été supprimé.",
      },
    },
    downloadLastFactsheet: {
      downloadLastFactsheet: "Télécharger la dernière factsheet",
      downloadingLastFactsheet: "Téléchargement...",
      needLogin: {
        text: "Pour télécharger ce document, vous devez être authentifié.",
        title: "Vous devez être authentifié",
      },
    },
    manualVerifyEmail: {
      forceVerification: "Forcer la vérification de l'e-mail",
      verified: "E-mail vérifié",
      notify: {
        errorText: "La vérification forcée de l'e-mail a échoué.",
        successText: "L'e-mail de l'utilisateur a été vérifié manuellement.",
      },
    },
    riskProfile: {
      higherRisk: "Risque plus élevé",
      lowerRisk: "Risque plus faible",
    },
  },
  graphs: {
    logScale: "Échelle logarithmique",
    notEnoughData:
      "Pas assez de données pour tracer ce graphique, veuillez sélectionner une plage de dates plus longue.",
    needMoreData:
      "Pour calculer cette métrique, une certaine quantité de données au début est nécessaire. Élargissez la période de temps pour avoir accès à cette métrique.",
  },
  holdingDataAdjustments: {
    categorise: {
      addCategory: {
        button: "Ajouter une catégorie",
        prompt: {
          category: "Catégorie",
          product: "Produit",
          property: "Propriété",
          title: "Ajouter une catégorie",
          value: "Valeur",
          valueAlreadyHasCategory: "Cette valeur est déjà associée à une catégorie.",
        },
      },
      exportCategories: {
        button: "Exporter les catégories au format CSV",
        buttonTooltip:
          "Téléchargez les correspondances de catégories affichées sous forme de fichier CSV.",
      },
      importCategories: {
        button: "Importer des catégories depuis un CSV",
        buttonTooltip:
          "Importez un fichier CSV pour mettre à jour en masse les correspondances de catégories.",
        importPrompt: {
          buttonCancel: "Annuler",
          buttonImport: "Importer",
          text: "Téléchargez un fichier CSV correctement formaté pour mettre à jour vos correspondances. Nous vous recommandons d'exporter d'abord la correspondance actuelle pour vérifier la structure des colonnes. Vous pouvez télécharger un fichier partiel ne contenant que les lignes nouvelles ou modifiées ; les données non mentionnées ne seront pas modifiées.",
          title: "Importer des catégories via CSV",
        },
        importErrorsPrompt: {
          close: "Fermer",
          selectErrorType: "Sélectionnez le type d'erreur :",
          title: "Erreurs de validation CSV",
          columns: {
            firstRow: "Première ligne",
            productName: "Nom du produit",
            property: "Propriété",
            rowIndex: "Index de ligne",
            value: "Valeur",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Les colonnes requises suivantes sont manquantes :",
            notExpectedColumns: "Les colonnes inattendues suivantes ont été trouvées :",
            title: "Non-concordance des colonnes",
            text: 'Assurez-vous que l\'entête CSV contient les colonnes suivantes : "product_name, property, value, category".',
          },
          nonExistentProductName: {
            title: "Nom de produit inconnu",
            text: "Assurez-vous que tous les noms de produits existent.",
          },
          invalidPropertyForProductName: {
            title: "Propriété invalide pour le produit",
            text: 'Certaines propriétés ne sont pas disponibles pour les produits sélectionnés. Supprimez-les ou vérifiez-les dans l\'onglet "Holding Data" sous la section "Produits" de la section Admin.',
          },
          duplicatedCategory: {
            title: "Catégorie dupliquée pour une valeur",
            text: "Supprimez les entrées de catégorie en double pour la même valeur.",
          },
          papaparseMissingQuotes: {
            title: "Guillemet non fermé",
            text: "L’analyse du fichier CSV a échoué car une chaîne entre guillemets n’a pas été correctement fermée. Veuillez vérifier l’absence de guillemets de fermeture dans vos données.",
          },
          papaparseUndetectableDelimiter: {
            title: "Délimiteur indétectable",
            text: "L’analyse du fichier CSV a échoué. Aucun délimiteur courant n’a été détecté. Veuillez vous assurer que votre fichier utilise un seul type de délimiteur, généralement une virgule ou un point-virgule.",
          },
          papaparseTooFewFields: {
            title: "Trop peu de champs",
            text: "L’analyse du fichier CSV a échoué. Certaines lignes contiennent moins de 4 champs requis. Veuillez vérifier la structure de votre fichier.",
          },
          papaparseTooManyFields: {
            title: "Trop de champs",
            text: "L’analyse du fichier CSV a échoué. Certaines lignes contiennent plus que les 4 champs attendus. Veuillez vérifier la structure de votre fichier.",
          },
        },
      },
      saveCategories: {
        button: "Enregistrer toutes les modifications",
        saveSuccess: "Les catégories des données de holdings ont été enregistrées avec succès.",
        updateWarningPrompt: {
          title: "Impact de l'enregistrement des modifications",
          text: "Vous êtes sur le point d'enregistrer la catégorisation après avoir modifié une ou plusieurs lignes en supprimant ou en mettant à jour leur catégorie. Si les catégories affectées possèdent des traductions enregistrées, celles-ci peuvent être supprimées — sauf si la catégorie existe toujours pour le même produit via une autre valeur. De plus, si ces catégories étaient utilisées pour modifier les constituants de holdings, ces remplacements seront également supprimés — sauf si la catégorie existe encore pour le même produit via une autre valeur.",
        },
      },
    },
    translate: {
      exportTranslations: {
        button: "Exporter les traductions en CSV",
        buttonTooltip:
          "Télécharger les correspondances de traductions affichées sous forme de fichier CSV.",
      },
      importTranslations: {
        button: "Importer des traductions depuis un CSV",
        buttonTooltip: "Importer un fichier CSV pour mettre à jour les traductions en masse.",
        importPrompt: {
          buttonCancel: "Annuler",
          buttonImport: "Importer",
          text: "Téléchargez un fichier CSV correctement formaté pour mettre à jour vos correspondances. Nous vous recommandons d'exporter d'abord la correspondance actuelle pour vérifier la structure des colonnes. Vous pouvez télécharger un fichier partiel ne contenant que les lignes nouvelles ou modifiées ; les données non mentionnées ne seront pas modifiées.",
          title: "Importer des traductions via un CSV",
        },
        importErrorsPrompt: {
          close: "Fermer",
          selectErrorType: "Sélectionner le type d'erreur :",
          title: "Erreurs de validation du CSV",
          columns: {
            firstRow: "Première ligne",
            language: "Langue",
            productName: "Nom du produit",
            property: "Propriété",
            rowIndex: "Index de ligne",
            category: "Catégorie",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Les colonnes requises suivantes sont manquantes :",
            notExpectedColumns: "Les colonnes inattendues suivantes ont été trouvées :",
            title: "Non-concordance des colonnes",
            text: (ctx) =>
              `Assurez-vous que l'en-tête du CSV contient les colonnes suivantes : ${ctx.named("expectedColumns").join(", ")}.`,
          },
          nonExistentProductName: {
            title: "Nom de produit inconnu",
            text: "Assurez-vous que tous les noms de produit existent.",
          },
          invalidPropertyForProductName: {
            title: "Propriété invalide pour le produit",
            text: 'Certaines propriétés ne sont pas disponibles pour les produits sélectionnés. Supprimez-les ou vérifiez-les dans l’onglet "Holding Data", section "Produits" du panneau d’administration.',
          },
          duplicatedTranslations: {
            title: "Traductions en double pour une valeur",
            text: "Supprimez les entrées de traduction en double pour une même valeur.",
          },
          invalidCategoryForProductNameAndProperty: {
            title: "Catégorie invalide pour la propriété du produit",
            text: "La catégorie sélectionnée n'existe pas pour cette propriété du produit. Veuillez vérifier les catégories autorisées.",
          },
          invalidTranslationLangForProductName: {
            title: "Langue non disponible pour le produit",
            text: "Vous ne pouvez pas fournir une traduction dans une langue que le produit ne prend pas en charge. Veuillez exporter le CSV et vérifier une ligne du produit pour voir les langues disponibles.",
          },
          papaparseMissingQuotes: {
            title: "Guillemet non fermé",
            text: "L’analyse du fichier CSV a échoué car une chaîne entre guillemets n’a pas été correctement fermée. Veuillez vérifier l’absence de guillemets de fermeture dans vos données.",
          },
          papaparseUndetectableDelimiter: {
            title: "Délimiteur indétectable",
            text: "L’analyse du fichier CSV a échoué. Aucun délimiteur courant n’a été détecté. Veuillez vous assurer que votre fichier utilise un seul type de délimiteur, généralement une virgule ou un point-virgule.",
          },
          papaparseTooFewFields: {
            title: "Trop peu de champs",
            text: "L’analyse du fichier CSV a échoué. Chaque ligne doit contenir le même nombre de colonnes que l’en-tête. Actuellement, certaines lignes ont moins de colonnes que prévu. Veuillez vérifier la structure de votre fichier.",
          },
          papaparseTooManyFields: {
            title: "Trop de champs",
            text: "L’analyse du fichier CSV a échoué. Chaque ligne doit contenir le même nombre de colonnes que l’en-tête. Actuellement, certaines lignes ont plus de colonnes que prévu. Veuillez vérifier la structure de votre fichier.",
          },
        },
      },
      saveTranslations: {
        button: "Enregistrer toutes les modifications",
        saveSuccess: "Traductions des données de positions enregistrées avec succès.",
      },
    },
    override: {
      exportOverrides: {
        button: "Exporter les remplacements en CSV",
        buttonTooltip: "Téléchargez les remplacements affichés au format CSV.",
      },
      importOverrides: {
        button: "Importer des remplacements depuis un CSV",
        buttonTooltip: "Importez un fichier CSV pour mettre à jour les remplacements en masse.",
        importPrompt: {
          buttonCancel: "Annuler",
          buttonImport: "Importer",
          text: "Téléchargez un fichier CSV correctement formaté pour mettre à jour vos correspondances. Nous vous recommandons d'exporter d'abord la correspondance actuelle pour vérifier la structure des colonnes. Vous pouvez télécharger un fichier partiel ne contenant que les lignes nouvelles ou modifiées ; les données non mentionnées ne seront pas modifiées.",
          title: "Importer des remplacements via CSV",
        },
        importErrorsPrompt: {
          close: "Fermer",
          selectErrorType: "Sélectionner le type d'erreur :",
          title: "Erreurs de validation du CSV",
          columns: {
            category: "Catégorie",
            currency: "Devise",
            firstRow: "Première ligne",
            holdingName: "Nom de la position",
            isin: "ISIN",
            productName: "Nom du produit",
            property: "Propriété",
            rowIndex: "Index de ligne",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Colonnes obligatoires manquantes :",
            notExpectedColumns: "Colonnes inattendues trouvées :",
            title: "Colonnes incorrectes",
            text: (ctx) =>
              `Assurez-vous que l'en-tête CSV contient les colonnes suivantes : ${ctx.named("expectedColumns").join(", ")}.`,
          },
          unknownProductName: {
            title: "Nom de produit inconnu",
            text: "Certains noms de produit dans votre fichier ne correspondent à aucun produit existant. Vérifiez les fautes de frappe ou les noms invalides.",
          },
          invalidPropertyForProductName: {
            title: "Propriété invalide pour le produit",
            text: 'Certaines propriétés ne sont pas disponibles pour les produits sélectionnés. Supprimez-les ou consultez-les dans l’onglet "Données de holding" de la section "Produits" du panneau d’administration.',
          },
          unknownOverrideCategory: {
            title: "Catégorie de remplacement inconnue",
            text: "Un ou plusieurs remplacements utilisent une catégorie inexistante pour le produit et la propriété concernés. Vérifiez les catégories disponibles avant d'importer.",
          },
          invalidConstituent: {
            title: "Clé de constituant invalide",
            text: "Certaines lignes font référence à des constituants (Nom du produit, Nom de la position, ISIN, Devise) inexistants. Veuillez les corriger ou les supprimer.",
          },
          duplicateConstituent: {
            title: "Remplacements dupliqués",
            text: "Plusieurs remplacements ont été trouvés pour le même constituant (Nom du produit, Nom de la position, ISIN, Devise). Ne conservez qu’un seul enregistrement par constituant.",
          },
          papaparseMissingQuotes: {
            title: "Guillemet non fermé",
            text: "L’analyse du fichier CSV a échoué car une chaîne entre guillemets n’a pas été correctement fermée. Veuillez vérifier l’absence de guillemets de fermeture dans vos données.",
          },
          papaparseUndetectableDelimiter: {
            title: "Délimiteur indétectable",
            text: "L’analyse du fichier CSV a échoué. Aucun délimiteur courant n’a été détecté. Veuillez vous assurer que votre fichier utilise un seul type de délimiteur, généralement une virgule ou un point-virgule.",
          },
          papaparseTooFewFields: {
            title: "Trop peu de champs",
            text: "L’analyse du fichier CSV a échoué. Chaque ligne doit contenir le même nombre de colonnes que l’en-tête. Actuellement, certaines lignes ont moins de colonnes que prévu. Veuillez vérifier la structure de votre fichier.",
          },
          papaparseTooManyFields: {
            title: "Trop de champs",
            text: "L’analyse du fichier CSV a échoué. Chaque ligne doit contenir le même nombre de colonnes que l’en-tête. Actuellement, certaines lignes ont plus de colonnes que prévu. Veuillez vérifier la structure de votre fichier.",
          },
        },
      },
      saveOverrides: {
        button: "Enregistrer toutes les modifications",
        saveSuccess: "Les remplacements de données de holding ont été enregistrés avec succès.",
      },
    },
  },
  holdingData: {
    others: "Autres",
  },
  images: {
    uploadImage: {
      darkening: "Obscurcissement",
      file: "Fichier",
      noFile: "Pas de fichier",
      noImage: "Pas d'image",
      promptTitle: "Télécharger une image",
      selectFile: "Sélectionnez un fichier",
      selectNewImage: "Sélectionnez une image",
      submit: "Soumettre",
      submitting: "Soumission en cours...",
      errorTitleTooLarge: "Image trop grande",
      errorMessageTooLarge:
        "L'image est trop grande. Veuillez sélectionner une autre image dont la taille est inférieure à 30 Mo.",
      warningTitleVeryLarge: "Image très grande",
      warningMessageVeryLarge:
        "L'image est très grande. Elle ralentira le chargement des pages qui l'affichent. Pour de meilleures performances, il est conseillé d'utiliser des images de moins de 10 Mo.",
    },
  },
  linkPrompt: {
    componentLinkedTo: "Ce composant est lié à :",
    currentView: "Vue actuelle",
    currentShareClass: "Classe de parts actuelle",
    linkThroughViewsTooltip:
      'L\'activation de cette fonctionnalité crée une liaison synchronisée entre les composants de plusieurs vues. Par exemple, lier les vues "Factsheet" et "Aperçu" permet de s\'assurer que toute modification apportée à un composant partagé est mise à jour simultanément sur les deux vues. Important : le contenu du composant lié est dupliqué à partir de la vue source que vous êtes en train de modifier. Si vous créez le lien alors que vous modifiez le composant "description" de la vue "Factsheet", le composant "description" de la vue "Factsheet" est copié dans la vue "Aperçu"',
    linkThroughShareClassesTooltip:
      'L\'activation de cette fonction crée une connexion synchronisée entre les composants de plusieurs classes de parts. Par exemple, le fait de lier "Mon produit - Classe A" et "Mon produit - Classe B" garantit que toute modification apportée à un composant partagé est mise à jour simultanément dans les deux classes de parts. Important : le contenu du composant lié est dupliqué à partir de la vue source que vous êtes en train de modifier. Si vous créez le lien alors que vous modifiez le composant "description" de la vue "Mon produit - Classe A", le composant "description" de "Mon produit - Classe A" est copié dans "Mon produit - Classe B" et remplace donc le composant "description" de "Mon produit - Classe B".',
    linkThroughShareClassesForbiddenCrossProductTooltip:
      "Ce composant affiche des données pour toutes les classes de parts, il est donc toujours lié à toutes les classes de parts du produit. Vous ne pouvez pas délier les classes de parts individuellement pour cette raison ; seuls les liens vers d'autres vues peuvent être supprimés.",
    linkedWithViews: "En lien avec les vues suivantes",
    linkedWithShareClasses: "En lien avec les classes de parts suivantes",
    view: "Vue",
    shareClass: "Classe de parts",
    title: (ctx) => `Editer le lien de ${ctx.named("componentId")}`,
    unlink: "Délier",
    unlinking: "Déliement...",
    unsavedChangesAlert:
      "Vous avez des modifications non enregistrées. Si vous quittez sans sauvegarder, elles seront perdues.",
    confirmSaveDialog: {
      computingNewLinks: "Calcul des nouveaux liens...",
      onceLinked:
        "Une fois liés, lorsqu'une modification est appliquée à un composant dans l'un de ces emplacements (y compris l'emplacement actuel), tous les autres composants liés seront mis à jour de la même manière. Veuillez confirmer que vous souhaitez procéder à la sauvegarde.",
      overwrittenExistingComponent: "Écrasement d'un composant avec le même identifiant",
      overwrittenExistingComponentTooltip: (ctx) =>
        `Avertissement : Il existe déjà un composant avec l'ID '${ctx.named(
          "componentId"
        )}' à cet emplacement, il sera donc écrasé par ce composant si vous le liez.`,
      title: "Confirmation de la sauvegarde des nouveaux liens",
      youAreAboutToLink:
        "Vous êtes sur le point de lier le composant actuel aux composants situés aux emplacements suivants :",
    },
    overviewStyle: {
      title: "Modifier les liens dans le style de l’aperçu",
      saveSuccess: "La mise à jour des liens de style a été effectuée avec succès.",
    },
    reportFooter: {
      title: "Modifier les liens dans le pied de page du rapport",
      saveSuccess: "La mise à jour des liens du pied de page a été effectuée avec succès.",
    },
    reportHeader: {
      title: "Modifier les liens dans l'en-tête du rapport",
      saveSuccess: "La mise à jour des liens de l'en-tête a été effectuée avec succès.",
    },
    reportStyle: {
      title: "Modifier les liens dans le style du rapport",
      saveSuccess: "La mise à jour des liens de style a été effectuée avec succès.",
    },
    notify: {
      linkSaveSuccess: (ctx) =>
        `La mise à jour de la liaison de '${ctx.named(
          "componentId"
        )}' a été effectuée avec succès. `,
    },
    multiselect: {
      placeholderShareClasses: "Sélectionner les classes de parts à lier",
      placeholderViews: "Sélectionner les vues à lier",
      selectLabel: "Appuyer sur la touche Entrée pour sélectionner",
      deselectLabel: "Appuyer sur la touche Entrée pour supprimer",
      selectedLabel: "Sélectionnée",
    },
    overviewHeader: {
      title: "Modifier le lien de l'en-tête de l'aperçu",
      saveSuccess:
        "La mise à jour de la liason de l'en-tête de l'aperçu a été effectuée avec succès",
    },
  },
  pricesManagement: {
    addData: "Ajouter une donnée",
    autoDataUpdate: "Vos données sont mises à jour automatiquement.",
    date: "Date",
    datePlaceholder: "AAAA-MM-JJ",
    dateValidationError: "Vous ne pouvez pas ajouter une date qui a déjà une valeur.",
    exportCsvButton: "Exporter en CSV",
    importCsvButton: "Importer depuis un CSV",
    launchPriceUpdateButton: "Lancer la mise à jour",
    launchPriceUpdateTooltip:
      "En cliquant sur ce bouton, vous forcez une mise à jour en récupérant les dernières données depuis la source normalement utilisée pour la mise à jour automatique quotidienne (si ces données sont mises à jour automatiquement). Les données peuvent mettre quelques minutes à être récupérées et mises à jour.",
    launchPriceUpdateRunningTooltip: "Les prix sont en cours de récupération.",
    loadingData: "Chargement des données...",
    price: "Prix",
    priceAdj: "Prix (ajusté)",
    priceAdjTooltip:
      "En général, les prix ajustés désignent les prix ajustés pour tenir compte des dividendes, des divisions et d'autres événements. S'il n'est pas fourni, il est supposé être le même que le prix.",
    priceAdjTooltipTable:
      "En général, les prix ajustés désignent les prix ajustés pour tenir compte des dividendes, des divisions et d'autres événements.",
    refreshButton: "Actualiser",
    removeData: "Supprimer une donnée",
    benchmarks: {
      noBenchmark: "Aucun benchmark n'est disponible pour ce produit.",
    },
    dialog: {
      removeData: {
        title: "Supprimer un point de donnée",
        text: "Vous allez supprimer complètement un point de donnée. Êtes-vous sûr?",
      },
    },
    importCsvText: {
      para1:
        "Le fichier d'entrée doit être au format CSV, avec deux ou trois colonnes et une ligne d'en-tête.",
      para2:
        "La première colonne doit être constituée de dates et la deuxième de nombres (le prix à la date correspondante). La troisième colonne est facultative et, si elle est indiquée, elle doit être composée de chiffres correspondant au prix ajusté ; si elle n'est pas indiquée, les prix ajustés sont supposés être les mêmes que les prix d'origine.",
      para3:
        "Veuillez vous assurer que votre fichier CSV est valide afin d'éviter tout problème lors de la lecture et de l'analyse des données.",
    },
    notify: {
      dateUsedMultipleTimeError:
        "Plusieurs prix sont associés à une même date. Vous devez vous assurer qu'un prix unique est attribué à chaque date.",
      launchSuccessText:
        "La mise à jour des prix a été lancée avec succès. Veuillez actualiser dans quelques minutes pour voir les résultats.",
      launchErrorText:
        "Erreur lors du lancement de la mise à jour des prix, veuillez nous contacter.",
      nanFound:
        "Des valeurs vides ont été trouvées, veuillez vous assurer que toutes les lignes et colonnes contiennent une valeur.",
      numberFormatError:
        'Au moins un des nombres a un format non reconnu. Idéalement, vous ne devriez pas utiliser de séparateur pour les milliers et utiliser un point pour le séparateur décimal, car c\'est le format attendu. Par exemple, "102.12", "1380.25", "18.952", ...',
      saveErrorText: "Erreur lors de la mise à jour des prix, veuillez nous contacter.",
      saveSuccessText: "Les prix ont été mis à jour avec succès.",
    },
    prompt: {
      addPrice: "Ajouter un prix",
      importCsv: "Importer des données depuis un fichier CSV",
    },
  },
  tables: {
    metricsTable: {
      na: "N/A",
      name: "Nom",
      showLess: "Afficher moins",
      showMore: "Afficher plus",
    },
    monthlyReturnsTable: {
      benchmark: "Benchmark",
      return: "Rendement",
    },
    performanceTable: {
      computedFromTo: (ctx) =>
        `Performance calculée du ${ctx.named("firstDate")} au ${ctx.named("lastDate")}.`,
      notAvailableData:
        "Données non disponibles soit parce qu'il n'y a pas assez de jours pour les calculer, soit parce que les données ne sont pas significatives (par exemple, ratio de sharpe négatif), soit parce que l'indice de référence n'est pas toujours disponible pendant la période sélectionnée.",
    },
    holdingsTable: {
      noDataYet: "Ce composant ne contient pas encore de données.",
      holdingFields: {
        currency: "Devise",
        holdingName: "Nom",
        isin: "ISIN",
        value: "Valeur",
        weight: "Poids",
      },
      totalOfPortfolio: "Total du portefeuille",
      holdingsCountSummary: (ctx) => `${ctx.named("shown")} positions sur ${ctx.named("total")}`,
    },
    liquidityAnalysisTable: {
      noDataYet: "Ce composant ne contient pas encore de données.",
      description: "Description",
      isin: "ISIN",
      currency: "Devise",
      aumInLocalCurrency: (ctx) => `AUM (${ctx.named("currency")})`,
      weight: "Poids",
      lessThanOneDay: "0-1 jour",
      twoToSevenDays: "2-7 jours",
      eightToThirtyDays: "8-30 jours",
      thirtyOneToNinetyDays: "31-90 jours",
      ninetyOneToOneHundredEightyDays: "91-180 jours",
      oneHundredEightyOneToThreeHundredSixtyFiveDays: "181-365 jours",
      moreThanThreeHundredSixtyFiveDays: ">365 jours",
      totalOfPortfolio: "Total du portefeuille",
    },
  },
  thirdParty: {
    vuePhoneNumberInput: {
      countrySelectorLabel: "Code pays",
      countrySelectorError: "Choisir un pays",
      phoneNumberLabel: "Numéro de téléphone",
      example: "Exemple :",
    },
  },
  videos: {
    uploadVideo: {
      file: "Fichier",
      noFile: "Pas de fichier",
      noVideo: "Pas de vidéo",
      selectFile: "Sélectionnez un fichier",
      selectNewVideo: "Sélectionnez une vidéo",
      errorTitleTooLarge: "Vidéo trop grande",
      errorMessageTooLarge:
        "La vidéo est trop grande. Veuillez sélectionner une autre vidéo dont la taille est inférieure à 30 Mo.",
      warningTitleVeryLarge: "Vidéo très grande",
      warningMessageVeryLarge:
        "La vidéo est très grande. Elle ralentira le chargement des pages qui l'affichent. Pour de meilleures performances, il est conseillé d'utiliser des vidéos de moins de 10 Mo.",
    },
  },
};
